export const SIGNUP_USER = "SIGNUP_USER"
export const SIGNUP_USER_SUCCESS = "SIGNUP_USER_SUCCESS"
export const SIGNUP_USER_FAILED = "SIGNUP_USER_FAILED"